import { UrlStatus as UrlApiStatus } from "../useAddExternalItemsWorkflow/useUrlVerificationNotificationsSubscription";

// status color classes + order in which totals per status are being displayed in UI
export const URL_STATUSES_UI_CONFIG = new Map([
  [UrlApiStatus.alreadyAdded, "text-ds-green-7"],
  [UrlApiStatus.canBeAdded, "text-ds-blue-7"],
  [UrlApiStatus.cannotBeAdded, "text-ds-orange-6"],
]);

export const URLS_MAX_COUNT = 40;
